import React from "react";
import PropTypes from "prop-types";
import { useMutation } from "@apollo/client";
import {
  EnhancedAddNewRoleModal,
  getCopywriting,
  getPlaceholders,
} from "src/allocation/components/EnhancedAddNewRoleModal";
import { useAllocationConfig } from "src/contexts/global/WorkspaceContext";
import { addNewVacantRole as addNewVacantRoleMutation } from "src/allocation/graphql/members.graphql";

const AddVacantRoleModal = ({
  isVisible,
  onHideModal,
  groupTypesLookup,
  targetGroupId,
  onVacanciesAdded,
}) => {
  const { supplyLabel, vacantRoleLabel } = useAllocationConfig();
  const copywriting = getCopywriting(supplyLabel);

  const [addNewVacantRole] = useMutation(addNewVacantRoleMutation);

  const saveVacantRoles = async (selectedGroupsFte) => {
    const people = getPlaceholders({
      targetGroupId,
      selectedGroupsFte,
      vacantRoleLabel,
    });
    return addNewVacantRole({
      variables: {
        input: {
          people,
        },
      },
    });
  };

  const handleSubmit = async ({ selectedGroupsFte, setErrorSaving }) => {
    try {
      const { data } = await saveVacantRoles(selectedGroupsFte);
      await onVacanciesAdded?.(data?.result);

      onHideModal(true);
    } catch (error) {
      setErrorSaving(true);
    }
  };

  return (
    <EnhancedAddNewRoleModal
      selectedChapterHeading={copywriting.PLACEHOLDER_DESCRIPTION}
      handleOnConfirm={handleSubmit}
      supplyLabel={supplyLabel}
      visible={isVisible}
      onHideModal={onHideModal}
      existingGroups={[]}
      groupTypesLookup={groupTypesLookup}
      targetGroupId={targetGroupId}
      withInput
      disableDecimal
      ignoreDisableGroup
      copywriting={copywriting}
    />
  );
};

AddVacantRoleModal.propTypes = {
  isVisible: PropTypes.bool,
  onHideModal: PropTypes.func,
  groupTypesLookup: PropTypes.object,
  targetGroupId: PropTypes.string,
  onVacanciesAdded: PropTypes.func,
};

export default AddVacantRoleModal;
